const data = {
  "thumbInput": {
    "helpfulnessPrompt": "Heeft dit je geholpen?",
    "helpfulAriaLabel": "Stem als nuttig",
    "unhelpfulAriaLabel": "Stem als niet nuttig",
    "inputPlaceholder": "Welke informatie mis je?",
    "submitButtonLabel": "Versturen",
    "loadingText": "Even bezig...",
    "successMessage": "Bedankt voor je feedback!",
    "errorMessage": "Er is iets fout gegaan"
  }
};

export default data;